<template>
  <div
    class="swiss-style-table my-6"
    :class="{ 'compact-margin': compactMargin }"
  >
    <table class="w-full">
      <thead>
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="index"
            class="py-3 px-4 text-sm tracking-wider font-medium"
            :class="{
              'with-spacing': index < headers.length - 1,
              'text-left': true,
              'last-column': index === headers.length - 1,
              nowrap: noWrapColumns.includes(index),
              'tighter-range': index === 1,
            }"
          >
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rowIndex) in rows"
          :key="rowIndex"
          :class="{ 'last-row': rowIndex === rows.length - 1 }"
        >
          <td
            v-for="(cell, cellIndex) in row"
            :key="cellIndex"
            class="py-4 px-4 align-top"
            :class="{
              'font-medium': cellIndex === emphasizeColumnIndex,
              'with-spacing': cellIndex < row.length - 1,
              'text-left last-column': cellIndex === row.length - 1,
              nowrap: noWrapColumns.includes(cellIndex),
            }"
          >
            <template
              v-if="cellIndex === statusColumnIndex && typeof cell === 'object'"
            >
              <div class="row alignCentreRow">
                <span>{{ cell.text }}</span>
              </div>
            </template>
            <template v-else-if="Array.isArray(cell)">
              {{ cell[0] }}
              <br v-if="cell[1]" />
              <span v-if="cell[1]" class="text-xs text-gray-500">{{
                cell[1]
              }}</span>
            </template>
            <template v-else>
              {{ cell }}
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "SwissStyleTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
      required: true,
    },
    statusColumnIndex: {
      type: Number,
      default: -1,
    },
    emphasizeColumnIndex: {
      type: Number,
      default: 1,
    },
    noWrapColumns: {
      type: Array,
      default: () => [],
    },
    compactMargin: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.swiss-style-table {
  margin-bottom: var(--clickableHeight);
}

.swiss-style-table.compact-margin {
  margin-bottom: calc(var(--clickableHeight) / 2);
}

.last-row td {
  border-bottom: none !important;
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.tracking-wider {
  letter-spacing: 0.07em;
}

th,
td {
  padding: var(--space) 0;
  text-align: start;
  align-content: baseline;
  font-size: calc(var(--smallFontSize) * 0.8);
}

thead th {
  border-bottom: 1px solid var(--border-mid);
}

tbody td {
  border-bottom: 1px solid var(--grey-darkestest);
}

.with-spacing {
  padding-right: 30px !important;
  line-height: 1.2rem;
}

.tighter-range {
  letter-spacing: 0.02em !important;
  padding-right: 6px !important;
}

.nowrap {
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

/* Add more specific selectors to ensure left alignment takes effect */
table thead tr th.text-left,
table tbody tr td.text-left {
  text-align: left !important;
}

.swiss-style-table table tr > td:last-child .row {
  justify-content: flex-end !important;
}

@media (max-width: 768px) {
  th,
  td {
    padding: var(--space) 0;
    text-align: start;
    font-size: calc(var(--smallFontSize) * 0.8);
  }

  .with-spacing {
    padding-right: 6px !important;
  }

  table thead tr th.text-left,
  table tbody tr td.text-left {
    text-align: left !important;
  }
}
</style>
